import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import {
  getTimesheetApi,
  getWeeklyTimesheetApi,
  submitWeeklyTimesheetApi,
} from "../../../slices/attendanceSlice";
import DatePicker from "react-datepicker";
import ArrowIconBlue from "../../../assets/Icons/ArrowIconBlue";
import moment from "moment";
import useEmployeeTimesheet from "../../../utils/custome-hooks/useEmployeeTimesheet";
import ReactQuill from "react-quill";
import ExDropdown from "../../../components/basic-components/ExDropdown";
import ExDatepickerMonth from "../../../components/basic-components/ExDatepickerMonth";

const MyRequestedTimesheet = () => {
  const [accordions, setAccordion] = useState(null);

  const dispatch = useAppDispatch();

  const weeklyTimesheet = useAppSelector(
    (state) => state.attendance.weeklyTimesheet
  );

  const statusList = [
    {
      key: "Rejected",
      Id: 1,
    },
    {
      key: "Approved",
      Id: 2,
    },
    {
      key: "Pending",
      Id: 3,
    },
  ];

  const [status, setStatus] = useState(statusList[2].key);

  const timesheet = useAppSelector((state) => state.attendance.timesheet);
  const userId = useAppSelector((state) => state?.login?.session?.userId);
  const memberDetail = useAppSelector((state) => state.company.memberDetails);
  const [weekSlots, setWeekSlots] = useState([]);
  const { getHoliday, employeeWorking, checkWeekSubmit } =
    useEmployeeTimesheet();

  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    console.log("you are in useEffect");
    createWeekSlots();
  }, [selectedDate]);

  useEffect(() => {
    dispatch(getWeeklyTimesheetApi({ employeeId: userId }));
  }, [dispatch, userId, status, selectedDate]);

  const getWeeklyTimesheet = () => {
    dispatch(getWeeklyTimesheetApi({ employeeId: userId }));
  };

  const createWeekSlots = () => {
    let slots = getWeeklySlotsToEndOfMonthWithCurrentMarked(selectedDate);
    setWeekSlots([...slots]);
    const startDate = new Date(slots[0].weekStart);
    const endDate = new Date(slots[slots.length - 1].weekEnd);
    const year = selectedDate.getFullYear();
    const day = moment(endDate, "DD/MM/YYYY").date();

    dispatch(
      getTimesheetApi({
        dateFrom: moment(`${startDate.getMonth() + 1}/01/${year}`).format(
          "YYYY-MM-DD"
        ),
        dateTo: moment(`${endDate.getMonth() + 1}/${day}/${year}`).format(
          "YYYY-MM-DD"
        ),
        employeeId: userId,
      })
    );
  };

  const toggleAccordion = (timesheet) => {
    if (accordions == timesheet.id) {
      setAccordion(null);
    } else {
      setAccordion(timesheet.id);
    }
  };

  function getWeeklySlotsToEndOfMonthWithCurrentMarked(date) {
    const now = new Date(date);
    const year = now.getFullYear();
    console.log(year, "this is year");
    const month = now.getMonth(); // 0 = Jan
    console.log(month, "monthmonth");

    const todayUTC = new Date(Date.UTC(year, month, now.getDate()));

    // First day of the month (UTC)
    const firstDay = new Date(Date.UTC(year, month, 1));
    const day = firstDay.getUTCDay(); // 0 = Sun, 1 = Mon, ...
    const offset = day === 0 ? 1 : (8 - day) % 7;
    const firstMonday = new Date(Date.UTC(year, month, 1 + offset));

    // Last day of the month
    const lastDay = new Date(Date.UTC(year, month + 1, 0));

    const slots = [];
    let currentStart = new Date(firstMonday);

    while (currentStart <= lastDay) {
      let currentEnd = new Date(currentStart);
      currentEnd.setUTCDate(currentEnd.getUTCDate() + 6);

      const weekStartStr = currentStart.toISOString().split("T")[0];
      const weekEndStr = currentEnd.toISOString().split("T")[0];

      // Check if today's UTC date falls within this slot
      const isCurrent = todayUTC >= currentStart && todayUTC <= currentEnd;
      const dates = [];
      for (
        let d = new Date(currentStart);
        d <= currentEnd;
        d.setUTCDate(d.getUTCDate() + 1)
      ) {
        dates.push(new Date(d).toISOString().split("T")[0]);
      }

      slots.push({
        weekStart: weekStartStr,
        weekEnd: weekEndStr,
        isCurrent: isCurrent,
        dates: dates,
      });

      currentStart.setUTCDate(currentStart.getUTCDate() + 7);
    }

    return slots;
  }

  const submitWeeklyTimesheet = (weekEnddate) => {
    dispatch(
      submitWeeklyTimesheetApi({
        employeeId: userId,
        date: moment(weekEnddate).format("YYYY-MM-DD"),
      })
    );
    getWeeklyTimesheet();
  };

  return (
    <>
      <div className="w-full flex items-center justify-between">
        {/* <div className="w-5/12">
          <ExDropdown
            title="" //this is used attribute for designatiion
            placeholder="Select"
            onChange={(e) => setStatus(e.key)}
            value={status.key}
            optionValue="Id"
            optionLabel="key"
            options={statusList}
            dropDownHeight="40px"
            dropDownBorderWidth="1px"
            dropDownBorderColor="#8C8C8C"
            //error={errors?.?.message}
            isMandatory={false}
            error={undefined}
          />
        </div> */}
        <div className="w-7/12">
          {/* <label>Select Month</label>
          <DatePicker
            className="h-10 border border-exgray-300/80 outline-none rounded-lg px-2  focus:ring-0"
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="MMMM YYYY"
            //excludeDates={[new Date("2024-05-01"), new Date("2024-06-01")]}
            showMonthYearPicker
            maxDate={new Date()}
          /> */}
          <ExDatepickerMonth
            name={""}
            title={"Select Month"}
            selectedDate={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="MMMM YYYY"
            maxDate={new Date()}
          />
        </div>
      </div>
      <div className="mt-4">
        {weekSlots.map((slot, i) => {
          var check = checkWeekSubmit(
            moment(slot.weekStart).format("DD/MM/YYYY"),
            moment(slot.weekEnd).format("DD/MM/YYYY")
          );
          if (check?.length > 0) {
            return (
              <div className="border border-exgray-100 mb-2 rounded-sm">
                <h1 className="bg-secondary-100 p-2">
                  Week {i + 1} ( {moment(slot.weekStart).format("DD/MM/YYYY")} -{" "}
                  {moment(slot.weekEnd).format("DD/MM/YYYY")} )
                </h1>
                <table className="w-full rounded-sm border-t border-exgray-200">
                  <thead className="py-1 bg-secondary-300">
                    <tr className="border-b border-exgray-100">
                      <th className="text-sm font-medium py-2 px-2 w-1.5/12 text-start">
                        Date
                      </th>
                      <th className="text-sm font-medium py-2 px-2 w-1.5/12 text-start">
                        Day
                      </th>
                      <th className="text-sm font-medium py-2 px-2 w-1.5/12 text-start text-nowrap">
                        Start-Time
                      </th>
                      <th className="text-sm font-medium py-2 px-2 w-1.5/12 text-start text-nowrap">
                        End-Time
                      </th>
                      <th className="text-sm font-medium py-2 px-2 w-1/12 text-center text-nowrap">
                        Working Hrs
                      </th>
                      <th className="text-sm font-medium py-2 px-2 w-5/12 text-center text-nowrap">
                        Task List
                      </th>
                      <th className="text-sm font-medium py-2 px-2 text-start text-nowrap">
                        Status
                      </th>
                    </tr>
                  </thead>

                  <tbody className="items-center justify-center">
                    {slot.dates.map((date) => {
                      if (
                        timesheet &&
                        employeeWorking(moment(date).format("YYYY/MM/DD"))
                      ) {
                        let attendance = employeeWorking(
                          moment(date).format("YYYY/MM/DD")
                        );
                        var startTime = moment(attendance?.checkIn);
                        var endTime = moment(attendance?.checkOut);
                        var dif = moment.duration(endTime.diff(startTime));
                        let isHalfDay =
                          dif.hours() + parseFloat(`0.${dif.minutes()}`) < 8.3;

                        return (
                          <tr
                            className={`${
                              moment(date).format("dddd") == "Sunday" ||
                              moment(date).format("dddd") == "Saturday" ||
                              getHoliday(date)
                                ? "bg-exgray-200"
                                : isHalfDay
                                ? "bg-yellow-200"
                                : ""
                            } items-center  `}
                          >
                            <td className="text-nowrap text-sm w-1.5/12 px-1 py-2">
                              {moment(date).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2">
                              {moment(date).format("dddd")}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2">
                              {moment(attendance.checkIn).format("LT")}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2">
                              {attendance?.status
                                ? moment(attendance.checkOut).format("LT")
                                : ""}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2 text-center">
                              {attendance?.status
                                ? `${dif.hours()}:${
                                    dif.minutes() < 10
                                      ? "0" + dif.minutes()
                                      : dif.minutes()
                                  }`
                                : ""}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2">
                              <ReactQuill
                                // style={{ paddingBottom: -15, marginBottom: -35 }}
                                value={attendance?.dailyReport?.dailyReport[0]}
                                readOnly={true}
                                theme={"bubble"}
                              />
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2">
                              {attendance.weeklyApprovedStatus}
                            </td>
                          </tr>
                        );
                      } else if (timesheet && getHoliday(date)) {
                        return (
                          <tr className={`bg-secondary-400 items-center `}>
                            <td className="text-nowrap text-sm w-1.5/12 px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2 text-center"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                          </tr>
                        );
                      } else if (timesheet && moment(date).isBefore(moment())) {
                        return (
                          <tr
                            className={`${
                              moment(date).format("dddd") == "Sunday" ||
                              moment(date).format("dddd") == "Saturday"
                                ? "bg-green-200"
                                : "bg-orange-400"
                            }  items-center `}
                          >
                            <td className="text-nowrap text-sm w-1.5/12 px-1 py-2">
                              {moment(date).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2">
                              {moment(date).format("dddd")}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2 text-center"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr
                            className={`${
                              moment(date).format("dddd") == "Sunday" ||
                              moment(date).format("dddd") == "Saturday"
                                ? "bg-green-200"
                                : ""
                            }  items-center `}
                          >
                            <td className="text-nowrap text-sm w-1.5/12 px-1 py-2">
                              {moment(date).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2">
                              {moment(date).format("dddd")}
                            </td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2 text-center"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                            <td className="text-nowrap text-sm px-1 py-2"></td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
                <div className="flex justify-end m-2">
                  {check?.length > 0 ? (
                    <div className="flex">
                      <h1
                        className={`font-bold ${
                          check[0]?.status == "Pending"
                            ? "text-orange-500"
                            : check[0]?.status == "Rejected"
                            ? "text-red-300"
                            : "text-green-500"
                        }`}
                      >
                        {check[0]?.status}
                      </h1>
                      {/* <h1 className="text-green-500 font-bold">Submitted</h1> */}
                    </div>
                  ) : (
                    <button
                      disabled={
                        !moment.utc(slot.weekEnd).isBefore(moment.utc())
                      }
                      onClick={() => submitWeeklyTimesheet(slot.weekEnd)}
                      className={`px-3 py-1 text-exwhite-100 rounded-md ${
                        moment.utc(slot.weekEnd).isBefore(moment.utc())
                          ? "bg-secondary-500"
                          : "bg-exgray-300"
                      }`}
                    >
                      Submit for Approval
                    </button>
                  )}
                </div>
              </div>
            );
          }
        })}
      </div>
    </>
  );
};

export default MyRequestedTimesheet;
